app.controller('simulatorCtrl', [
    '$scope', '$rootScope', '$log', '$window', function ($scope, $rootScope, $log, $window) {
    	var vm = this;

    	vm.nested = window.parent != window;

    	vm.srcUrl = "";
    	vm.hidden = true;

    	$scope.$on("simulatorShowExercise", function() {
    		$log.debug("simulatorCtrl: simulatorShowExercise received");

    		vm.srcUrl = "/preview/exerciseperform";
    		vm.hidden = false;

    		angular.element(".simulator iframe.content")[0].src = vm.srcUrl;
    	});

        $scope.$on("simulatorShowFullExerciseFlowWithExercise", function() {
            $log.debug("simulatorCtrl: simulatorShowFullExerciseFlowWithExercise received");

            vm.srcUrl = "/preview/exercisebegin";
            vm.hidden = false;

            angular.element(".simulator iframe.content")[0].src = vm.srcUrl;
        });

    	$scope.$on("simulatorShowEvalExercise", function() {
       		$log.debug("simulatorCtrl: simulatorShowEvalExercise received");

			vm.srcUrl = "/preview/exerciseevalperform";
    		vm.hidden = false;

    		angular.element(".simulator iframe.content")[0].src = vm.srcUrl;
    	});

        vm.onMessageReceived = function(evt) {
            $scope.$apply(function() {
                if (evt.origin != window.location.origin) {
                    return;
                }

                var data = evt.data;
                if (data == "simulator.close") {
                    vm.close(); 
                }
            });
        }

        $window.addEventListener("message", vm.onMessageReceived, false);

    	vm.close = function() {
    		vm.hidden = true;
    	}
    }
]);
